import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import {
  TextWidth,
  ContentWidth,
  TextWidthExtended,
} from '@ta-interaktiv/react-disco-grid'
import { device } from '../../breakpoints'
import ListItem from 'components/ListItem'

interface FeaturedProps {
  data: any
  // handleItemClick: (id: string) => void
}

const Featured: FC<FeaturedProps> = ({
  data,
  // handleItemClick,
}): ReactElement => {
  return (
    <Container>
      {data.map((item: any, index: number) => (
        <ListItem
          // handleClick={(id: string) => {
          //   handleItemClick(id)
          // }}
          id={item.id}
          metadataId={item.metadataId}
          imageUrl={item.imageUrl}
          key={`item-${item.id}`}
          type={item.type}
          title={item.title}
          titleHeader={item.titleHeader}
          short={item.lead}
          description={item.texte}
          authorRating={item.note}
          videoId={item['Youtube ID']}
          trailerUrl={'https://www.youtube.com/embed/' + item['Youtube ID']}
          startDate={item['date de lancement']}
          links={item.providerLinks}
          favorite={item['favorite'] === true}
          highlighted={item['highlighted'] === true}
          alreadySeen={item['à revoir'] === true}
          providers={item.providerLinks}
        />
      ))}
    </Container>
  )
}

const Container = styled.div`
display: grid;
grid-gap: 1px;
background-color: #aaaaaa22;

@media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
  grid-template-columns: repeat(1, 1fr);
}

@media ${device.tablet}, @media ${device.laptop} {
  grid-template-columns: repeat(2, 1fr);
}
`

export default Featured
